<ng-template #modalVisorDocumento let-c="close" let-d="dismiss">
  <div class="modal-content">
    <div class="modal-header pb-0">
      <h2 class="mb-0">Documento: {{this.nombreArchivo}}</h2>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click');">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <ng-container>
        <div class="embed-responsive embed-responsive-16by9">
          <iframe class="embed-responsive-item" *ngIf="this.url !== ''" [src]="this.url | safe"></iframe>
        </div>
      </ng-container>

    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-info btn" (click)="d('Cross click'); "><i class="ft-x"></i>Cerrar</button>
  </div>
</ng-template>
